// errorHandling.js
import { store } from '../../store';
import { logout } from '../../store/reducers/accountSlice';
let isLoggingOut = false;
let logoutResetSubscribed = false;

// isLoggingOut only exists to collapse a burst of simultaneous 401s (e.g. several requests
// in flight when a token expires) into a single alert/logout, not to suppress every 401 for
// the rest of the session. Without this reset, a user who hits a 401, logs back in, and later
// hits a second 401 (token invalidated again) would have it silently swallowed -- no alert, no
// logout, no redirect -- since the flag was never cleared after the first time it fired.
//
// Subscribing lazily (on first handleApiError call) rather than at module-eval time matters:
// this module sits in a circular import (store -> reducers -> slices -> errorHandling ->
// store), so `store` is still undefined while this module is first evaluating. By the time
// handleApiError actually runs (a real API error, well after app bootstrap), the cycle has
// long since resolved.
const ensureLogoutResetSubscribed = () => {
  if (logoutResetSubscribed) return;
  logoutResetSubscribed = true;
  store.subscribe(() => {
    if (store.getState().account.isLoggedIn) {
      isLoggingOut = false;
    }
  });
};

export const handleApiError = (error) => {
  ensureLogoutResetSubscribed();
  if (error.response && error.response.status === 401) {
    if (!isLoggingOut) {
      isLoggingOut = true;
      alert('Your session has expired. Please log in again.');
      store.dispatch(logout());
    }
  }
};
